var _style, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1B;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FFCD00;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 13.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.929 39.7351)",
    className: "st0",
    width: 51,
    height: 51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 15.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.929 39.7351)",
    className: "st1",
    width: 46.8,
    height: 46.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 20,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.929 39.7351)",
    className: "st2",
    width: 38.3,
    height: 38.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainRoad);
export default __webpack_public_path__ + "static/media/main-road.e33c343bdb5a97a599519a500adc5335.svg";
export { ForwardRef as ReactComponent };